/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react'
import { AreaChart as AreaChartMobile } from '../Mobile/AreaChart'

export const AreaChart = (
    {
        color,
        data,
        testID,
    }:
        {
            color: string,
            testID?: string,
            data: {
                x: string,
                y: number,
                color?: string
            }[]
        }) => {
    return (
        <span data-testid={testID}>
            <AreaChartMobile
                gradient
                data={data}
                color={color}
            />
        </span>
    )
}